import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=214b0112&scoped=true&"
import script from "./BaseCheckbox.vue?vue&type=script&lang=ts&"
export * from "./BaseCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCheckbox.vue?vue&type=style&index=0&id=214b0112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214b0112",
  null
  
)

export default component.exports